import React, { useMemo } from 'react';

const VILLA_PATHS = [
    // ==========================================
    // 1. LEFT BUILDING (The Rustic Barn)
    // ==========================================
    
    // -- Roof --
    "M 40 420 L 180 250", // Left slope up
    "M 180 250 L 520 380", // Main Ridge
    "M 40 420 L 50 430", // Eave thickness
    "M 50 430 L 190 260", // Underside of eave
    // Roof Hatching (Tiles)
    "M 60 410 L 180 270",
    "M 80 400 L 200 260",
    "M 100 390 L 220 260",
    "M 120 380 L 240 270",
    "M 140 370 L 260 280",
    "M 160 360 L 280 290",
    "M 180 350 L 300 300",
    "M 200 340 L 320 310",
    "M 250 330 L 360 320", // Fading out towards right

    // -- Walls --
    "M 520 380 L 520 550", // Vertical divider wall (Right edge of left building)
    "M 40 430 L 80 600", // Left corner (obscured by bushes)

    // -- Upper Window 1 (Left) - Brick Lattice (Gelosia) --
    "M 220 320 L 330 340", // Top
    "M 220 320 L 220 410", // Left
    "M 330 340 L 330 430", // Right
    "M 220 410 L 330 430", // Bottom
    // Lattice pattern
    "M 230 330 L 240 330", "M 250 335 L 260 335", "M 270 340 L 280 340", "M 290 345 L 300 345", // Row 1
    "M 225 350 L 325 370", // Horizontal divider
    "M 230 360 L 240 360", "M 250 365 L 260 365", "M 270 370 L 280 370", // Row 2
    "M 225 380 L 325 400", // Horizontal divider
    
    // -- Upper Window 2 (Right) - Brick Lattice --
    "M 380 350 L 490 370", // Top
    "M 380 350 L 380 440", // Left
    "M 490 370 L 490 460", // Right
    "M 380 440 L 490 460", // Bottom
    // Lattice pattern
    "M 390 360 L 480 380", // Horizontal
    "M 390 390 L 480 410", // Horizontal
    "M 400 360 L 400 440", // Vertical suggestion
    "M 430 365 L 430 445", // Vertical suggestion
    "M 460 370 L 460 450", // Vertical suggestion

    // -- Arched Entrance with Rustic Roof --
    // The small roof over the door
    "M 300 480 L 470 510", // Roof line front
    "M 290 475 L 300 480", // Side detail
    "M 300 480 L 310 495", // Tile texture
    "M 340 490 L 350 505", // Tile texture
    "M 400 500 L 410 515", // Tile texture
    // The Arch
    "M 350 530 Q 390 515 440 540", // Arch top
    "M 350 530 L 350 620", // Left jamb
    "M 440 540 L 440 650", // Right jamb
    "M 390 525 L 390 650", // Door split center
    "M 350 580 Q 390 570 440 590", // Iron hinge/band

    // ==========================================
    // 2. WINTER GARDEN (Center Connection)
    // ==========================================
    // Replaces the old railing. A glass structure connecting left and right.
    
    "M 520 500 L 630 510", // Roof of winter garden
    "M 520 510 L 630 520", // Eave of winter garden
    "M 520 510 L 520 660", // Left frame
    "M 630 520 L 630 660", // Right frame (Corner of right building starts here)
    
    // Vertical Glass Panes
    "M 545 512 L 545 655", // Pane 1
    "M 570 515 L 570 658", // Pane 2
    "M 595 518 L 595 660", // Pane 3
    
    // Horizontal mullions
    "M 520 560 L 630 570", 
    "M 520 610 L 630 620",

    // ==========================================
    // 3. RIGHT BUILDING (Manor)
    // ==========================================
    
    // -- Structure --
    "M 630 450 L 630 670", // THE CORNER (Key perspective line)
    
    // -- Side Wall (Facing Left/Winter Garden) --
    // This is the wall from x=520 (behind winter garden) to x=630.
    // The Winter Garden is attached to it, but the upper part is visible.
    "M 520 380 L 630 450", // Roof line connecting to right building
    "M 530 390 L 630 460", // Eave detail

    // -- The Oculus (Circular Window) -- 
    // Located on the SIDE wall (Perspective distorted oval)
    "M 570 430 Q 590 435 590 455 Q 590 475 570 480 Q 550 475 550 455 Q 550 435 570 430",
    "M 570 440 Q 580 445 580 455 Q 580 465 570 470 Q 560 465 560 455 Q 560 445 570 440",
    "M 570 480 L 570 510", // Decorative drip line below

    // -- Front Facade (Facing Viewer/Right) --
    "M 630 450 L 900 500", // Roof line top
    "M 630 460 L 900 510", // Eave line
    
    // Upper Windows (Perspective)
    "M 660 510 L 700 515 L 700 550 L 660 545 Z", // Window 1
    "M 650 510 L 660 510", // Shutter 1
    "M 700 515 L 710 515", // Shutter 2
    
    "M 740 520 L 780 525 L 780 560 L 740 555 Z", // Window 2
    "M 730 520 L 740 520", // Shutter 1
    "M 780 525 L 790 525", // Shutter 2
    
    // Lower Door/Window (Arched)
    "M 670 600 C 670 580 710 580 710 600", // Arch top
    "M 670 600 L 670 650",
    "M 710 600 L 710 650",
    
    // ==========================================
    // 4. DRIVEWAY (Viale) & GROUND
    // ==========================================
    
    // Sweeping lines leading to the right building entrance area
    "M 200 700 Q 400 680 550 670", // Left edge of path
    "M 900 700 Q 750 680 650 670", // Right edge of path (merging towards building)
    
    // Path texture lines
    "M 300 700 Q 450 690 580 680",
    "M 400 700 L 500 690",
    "M 800 700 L 700 680",
    
    // ==========================================
    // 5. VEGETATION
    // ==========================================
    
    // -- Left Side: Tall Cypress / Reeds --
    "M 20 600 L 30 400", // Tall reed
    "M 30 620 L 50 350", // Very tall cypress trunk/stem
    "M 40 610 L 70 450",
    "M 60 630 Q 80 500 90 420", // Curved reed
    "M 100 650 Q 120 550 110 480",
    "M 10 550 Q 20 450 25 350 Q 30 450 40 550", // Cypress outline
    
    // Bushes at base of left building
    "M 50 580 Q 100 550 150 600",
    "M 140 590 Q 200 560 260 620",
    "M 150 500 L 160 550", // Stray branch
    
    // -- Right Side: Large Gnarly Tree --
    // Trunk
    "M 850 700 Q 820 550 840 450", // Left side of trunk
    "M 980 700 Q 920 550 940 450", // Right side of trunk
    
    // Main Branches
    "M 840 450 Q 820 350 750 250", // Large branch stretching left over roof
    "M 840 450 Q 880 350 900 250", // Branch up
    "M 940 450 Q 960 350 990 250", // Branch right
    
    // Secondary Branches / Twigs
    "M 750 250 L 700 200",
    "M 750 250 L 780 180",
    "M 900 250 L 880 150",
    "M 900 250 L 940 180",
    
    // Bark Texture (Gnarly)
    "M 860 650 Q 850 600 870 550",
    "M 900 670 Q 890 620 910 570",
    "M 850 480 Q 860 460 880 470", // Knot
    
    // -- Background Trees --
    // Behind Winter Garden/Right Building
    "M 600 400 L 605 320", // Thin cypress tip
    "M 720 480 L 725 400", // Thin cypress tip
    "M 750 480 L 755 420",
    
    // Extra scribbles for atmosphere
    "M 500 200 Q 600 220 700 210", // Cloud/Sky hint?
    "M 800 650 L 820 660", // Ground detail
];

const AnimatedPath = ({ d, color, delay, duration, strokeWidth }) => {
  return (
    <path
      d={d}
      stroke={color}
      strokeWidth={strokeWidth}
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      pathLength="1"
      className="opacity-0"
      style={{
        strokeDasharray: 1,
        strokeDashoffset: 1,
        animation: `drawAndFade ${duration}s ease-in-out infinite`,
        animationDelay: `${delay}s`,
      }}
    />
  );
};

const VectorBackground = () => {
  const colors = [
    '#ffffff', // White
    '#f0f9ff', // Sky 50
    '#e0f2fe', // Sky 100
    '#bae6fd', // Sky 200
    '#7dd3fc', // Sky 300
    '#38bdf8', // Sky 400
  ];

  const CYCLE_DURATION = 14; 
  const MAX_DELAY = 4;

  const randomizedPaths = useMemo(() => {
    return VILLA_PATHS.map((pathD, index) => {
      const color = colors[Math.floor(Math.random() * colors.length)];
      const duration = CYCLE_DURATION;
      const delay = Math.random() * MAX_DELAY;
      const strokeWidth = 0.4 + Math.random() * 0.8;

      return {
        id: index,
        d: pathD,
        color,
        duration,
        delay,
        strokeWidth,
      };
    });
  }, []);

  return (
    <div className="absolute inset-0 w-full h-full flex items-center justify-center pointer-events-none opacity-30 dark:opacity-20">
      <style>
        {`
          @keyframes drawAndFade {
            0% {
              stroke-dashoffset: 1;
              opacity: 0;
            }
            10% {
              opacity: 1;
            }
            25% {
              stroke-dashoffset: 0;
              opacity: 1;
            }
            75% {
              stroke-dashoffset: 0;
              opacity: 1;
            }
            90% {
              opacity: 0;
            }
            100% {
              stroke-dashoffset: -1; 
              opacity: 0;
            }
          }
        `}
      </style>
      <svg
        viewBox="0 0 1000 700"
        className="w-full h-full max-w-7xl max-h-[90vh]"
        preserveAspectRatio="xMidYMid meet"
      >
        {randomizedPaths.map((p) => (
          <AnimatedPath
            key={p.id}
            d={p.d}
            color={p.color}
            duration={p.duration}
            delay={p.delay}
            strokeWidth={p.strokeWidth}
          />
        ))}
      </svg>
    </div>
  );
};

export default VectorBackground;
